import Inputmask from "inputmask";

export default () => {
    const phoneInputs = document.querySelectorAll(".phone-input");
    const dateInputs = document.querySelectorAll(".date-input");

    if(phoneInputs) {
        phoneInputs.forEach((input) => {
            Inputmask("+999999999999999", {
                placeholder: ""
            }).mask(input);
        });
    };

    if(dateInputs) {
        dateInputs.forEach((input) => {
           let date = Inputmask("99/99/9999", {
                placeholder: "DD/MM/YYYY",
                alias: "datetime", 
                autoUnmask: true,
                removeMaskOnSubmit: true,
                inputFormat: "dd/mm/yyyy", 
                outputFormat: "yyyy-mm-dd",
                clearIncomplete: true,
            }).mask(input);           
        });
    };
}